module.exports = __webpack_public_path__ + "static/media/pool.e4a8d8fc.png";